import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Stack, styled, Typography } from '@mui/material';

import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image";

import { RootState } from "../store";
import MintDialog from "./MintDialog";
import { actions } from '../services/mint';
import MintPendingDialog from "./MintPendingDialog";


const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.primary.main,
}));

const HeroContent = styled('div')(
  ({ theme }) => ({
    backgroundColor: '#1b1b1b',
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingReft: theme.spacing(2),
    width: '100%',
    display: "flex",
    flexDirection: 'column',
    justifyContent: "flex-start",
    alignItems: "center",
    position: 'relative',
  })
);

const GroupImg = styled(Img)(() => ({
  width: '100%',
  maxWidth: 900,
  marginTop: 30,
}))

const HeroText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  textTransform: 'uppercase',
  fontSize: 30,
  [ theme.breakpoints.down('sm') ]: {
    fontSize: 16,
  },
}));


const HomeHero: React.FC = () => {
  const imgData = useStaticQuery(graphql`
    query {
      heroBanner: file(relativePath: {eq: "home/banner.png"}) {
        publicURL
        childImageSharp {
          fluid(maxWidth: 1000, webpQuality: 90) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `);

  const [ apeImg, setApeImg ] = useState<string>();
  const stats = useSelector((state: RootState) => state.nft);
  const [ mintModalOpen, setMintModalOpen ] = useState(false);
  const [ mintPendingOpen, setMintPendingOpen ] = useState(false);

  const dispatch = useDispatch();

  const ConnectWalletArgs = (result: boolean) => {
    setMintModalOpen(true);
  }

  const connectWallet = () => {
    dispatch(actions.connectWallet({
      onDone: ConnectWalletArgs
    }));
  }

  const closeMintModal = () => {
    setMintModalOpen(false);
  }

  const closeMintPending = () => {
    setMintPendingOpen(false);
  }

  const onMintStarted = () => {
    closeMintModal();
    setMintPendingOpen(true);
  }

  console.log('imgdata', imgData);

  return (
    <Root>
      <HeroContent>
        <Stack direction="column" spacing={3} sx={{ maxWidth: 700, flex: 1 }} alignItems="center">
          <HeroText>
            <strong>Hayape's</strong> are finally here, but don't confuse them with <strong>Apes</strong>
          </HeroText>
          <Button variant="contained" color="secondary" size="large" onClick={connectWallet}>
            Mint Now ({stats.currentPrice} eth)
          </Button>
        </Stack>
        <GroupImg fluid={imgData.heroBanner.childImageSharp.fluid} />

        <MintDialog open={mintModalOpen} onClose={closeMintModal} onMintStarted={onMintStarted} />
        <MintPendingDialog open={mintPendingOpen} onClose={closeMintPending} />

      </HeroContent>
    </Root>
  );
};

export default HomeHero;